import { AxiosInstance } from "axios"
import { ApiResponse } from "../../models/api"
import { Transport } from "../../models/transport"

export interface GetTransportsParams {
    limit?: number
    page?: number
    paginate?: boolean
    teamId?: string
    teamIds?: string
}

export class TransportsApi {
    private client: AxiosInstance

    constructor(client: AxiosInstance) {
        this.client = client
    }

    getTransports = (params?: GetTransportsParams) =>
        this.client.get<ApiResponse<Transport>>("transports", {
            params: {
                limit: params?.limit ?? 20,
                page: params?.page ?? 1,
                paginate: params?.paginate ?? true,
                teamId: params?.teamId ?? "",
                teamIds: params?.teamIds ?? "",
            },
        })
}
